import {useHttpRequest} from '~/composables/useHttpRequest';
import {endpoints} from '~/network/endpoints.js';

/**
 * X141: the setup guide's "Share an invite link to a competition or the club" step ticks once an admin copied, shared
 * or printed any of the club's invite links from Tap Leagues (or once anyone joined by one). Every Copy / Share of an
 * invite link reports itself here by the link's slug; the poster download reports itself on the API. Fire and
 * forget: a failed report never gets in the way of the copy or the share (the API refuses it under impersonation,
 * and a visitor-preview or signed-out call is simply dropped).
 */

/** The slug of an invite path ("/invite/abc123" → "abc123"), or null for any other path. */
export const inviteSlugOf = (path) => {
  const m = /^\/invite\/([^/?#]+)/.exec(path ?? '');
  return m ? m[1] : null;
};

export function useJoinLinkShared() {
  const {httpRequest} = useHttpRequest();

  const markJoinLinkShared = async (slug) => {
    if (!slug) return false;
    try {
      await httpRequest(endpoints.clubs.joinLinkShared(slug));
      return true;
    } catch {
      return false;
    }
  };

  return {markJoinLinkShared};
}
